module.exports = __webpack_public_path__ + "img/welcome-icon-02.2bece3ae.png";